import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnReasonDetailConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.Section>
        <Skeleton variant="text" width={60} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={220} height={20} />
        </Styles.ToggleRow>
        <Styles.TabsRow>
          <Skeleton variant="rounded" width={80} height={32} />
          <Skeleton variant="rounded" width={80} height={32} />
          <Skeleton variant="rounded" width={80} height={32} />
        </Styles.TabsRow>
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={200} height={24} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={180} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={200} height={24} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={260} height={20} />
        </Styles.ToggleRow>
        <Styles.TabsRow>
          <Skeleton variant="rounded" width={80} height={32} />
          <Skeleton variant="rounded" width={80} height={32} />
        </Styles.TabsRow>
        <Skeleton variant="rounded" width="100%" height={120} />
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={220} height={24} />
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={200} height={20} />
        </Styles.ToggleRow>
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={200} height={20} />
        </Styles.ToggleRow>
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={180} height={24} />
        <Skeleton variant="text" width="100%" height={20} />
        {Array.from({ length: 3 }).map((_, index) => (
          <Styles.SubReasonRow key={index}>
            <Skeleton variant="rounded" width={24} height={24} />
            <Styles.SubReasonBox>
              <Skeleton variant="rounded" width="100%" height={56} />
            </Styles.SubReasonBox>
            <Skeleton variant="rounded" width={24} height={24} />
          </Styles.SubReasonRow>
        ))}
        <Skeleton variant="rounded" width={180} height={40} />
      </Styles.Section>
    </Styles.Container>
  )
}

export default ReturnReasonDetailConfigurationSkeleton
